export const svgReportURL = `/assets/img/report_2.svg`;
